import { lazy } from "react";

/** Ein Session-Key für alle Chunk-Recovery-Pfade (lazy / ErrorBoundary / main). */
export const CHUNK_RELOAD_KEY = "wt:chunk-reload";

/** Legacy-Keys aus älteren Builds — beim Clear mit entfernen. */
const LEGACY_CHUNK_RELOAD_KEYS = [
  "wt:lazy-chunk-reload",
  "wt:chunk-reload-attempted",
  "wrtk:chunk-reload-once",
  "wt:admin:chunk-reload-attempted",
];

export function isChunkLoadError(error) {
  const msg = String(error?.message || error?.reason?.message || error?.reason || error || "").toLowerCase();
  return (
    msg.includes("failed to fetch dynamically imported module")
    || msg.includes("error loading dynamically imported module")
    || msg.includes("importing a module script failed")
    || msg.includes("chunkloaderror")
    || msg.includes("loading chunk")
    || msg.includes("loading css chunk")
  );
}

export function clearChunkReloadFlags() {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    for (const k of LEGACY_CHUNK_RELOAD_KEYS) sessionStorage.removeItem(k);
  } catch {
    /* ignore */
  }
}

/**
 * Einmaliger Hard-Reload bei veralteten JS-Chunks (typisch nach Client-Rebuild).
 * @returns {boolean} true wenn Reload ausgelöst wurde
 */
export function tryRecoverChunkError(error) {
  if (!isChunkLoadError(error)) return false;
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === "1") return false;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  } catch {
    /* sessionStorage blockiert — trotzdem einmal reloaden */
  }
  // Cache-Bust: index.html ist no-store, Query erzwingt frischen Einstieg.
  const url = new URL(window.location.href);
  url.searchParams.set("_wtchunk", String(Date.now()));
  window.location.replace(url.toString());
  return true;
}

/**
 * lazy() mit Retry + einmaligem Auto-Reload bei stale Chunks nach Rebuild/Deploy.
 */
export function lazyWithRetry(importer) {
  return lazy(async () => {
    try {
      const mod = await importer();
      clearChunkReloadFlags();
      return mod;
    } catch (error) {
      // Kurzer Retry (Netz/Race), dann Hard-Reload
      try {
        await new Promise((r) => setTimeout(r, 120));
        const mod = await importer();
        clearChunkReloadFlags();
        return mod;
      } catch (retryError) {
        if (tryRecoverChunkError(retryError) || tryRecoverChunkError(error)) {
          return new Promise(() => {});
        }
        throw retryError;
      }
    }
  });
}
